<template>
	<div class="app-manage-root pa-1">
		<v-data-table
		    :headers="headers"
			fixed-header
		    :items="apps"		   
		    class="elevation-1 app-table "
			disable-pagination
			hide-default-footer
			height="100%"
			width="100%"
			
			single-select
			show-select
			item-key="appId"
			v-model="selectedApp"
		  >
		</v-data-table>
	</div>
</template>

<script>
	import {default as AppApi} from "../../../../api/smp/sys/AppApi.js";
	
	export default {
		name: 'Smp-App-Manage',
		components: {
        },
        props:['tab'],
		data: () => ({
			headers:[
				{text: '编号',align: 'start',sortable: false,value: 'appId',width:80,divider:true},
				{ text: '代号', value: 'appCode',sortable: false ,width:260,divider:true},
				{ text: '名称', value: 'appName',sortable: false ,divider:true},
				{ text: '类型代号', value: 'typeId',sortable: false ,width:100},
				{ text: '类型', value: 'typeName',sortable: false ,width:100},
				{ text: 'SSO', value: 'ssoSupport',sortable: false ,width:100},			
				
			],
			apps:[],
			selectedApp:[]
		}),
		methods:{
			async  errMsg(title,text){
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
			loadApps(){
				let me = this;
				AppApi.queryAllApp().then(function(resp){
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取APP信息失败':msg;
						throw new Error(msg);
						return;
					}
                    console.log("queryAllApp return:");
                    console.log(data);
					let apps = data.data.apps;
					apps.forEach(function(item){
						item.ssoSupport = "";
						if(item.sso_flag ==1)
							item.ssoSupport = "支持";
						else
							item.ssoSupport = "不支持";		
					});
					me.apps = apps;
				}).catch(function(err){
					me.errMsg('错误','获取APP信息失败:'+err.message);
				});
			}
		},
		computed:{		
		},
		created(){
			this.loadApps();
		}
	}
</script>

<style scoped>
	.app-manage-root{
		max-width:100%;
		max-height:100%;
		width:100%;
		height:100%;
	}
	.app-table{		
		width:100%;
		height:100%;
		max-width:100%;
		max-height:100%;	   
	}
</style>
